import React from 'react';
import { Route } from 'react-router-dom';
import GiftCards from './GiftCards';

const routes = [
  <Route key="giftCards" path="/gift-cards"><GiftCards/></Route>
];

export default routes;
